import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import { list, getXML } from '../actions/rules-list';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
const reducer = createReducer(InitialState.rulesList, (builder)=>{
    builder.addCase(UIActions.logout.type, ()=>({
            ...InitialState.rulesList
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.rulesList
        }));
    builder.addCase(list.fulfilled, (state, action)=>({
            ...state,
            decisionDefinitions: action.payload
        }));
    builder.addCase(getXML.pending, (state, action)=>({
            ...state,
            selectedDecisionName: action.meta.arg.decisionName,
            selectedDiagramXML: null
        }));
    builder.addCase(getXML.rejected, (state)=>({
            ...state,
            selectedDiagramXML: null
        }));
    builder.addCase(getXML.fulfilled, (state, action)=>({
            ...state,
            selectedDiagramXML: action.payload
        }));
});
export default reducer;
